import { render, staticRenderFns } from "./callRecord.vue?vue&type=template&id=d8c4ea50&scoped=true&"
import script from "./callRecord.vue?vue&type=script&lang=js&"
export * from "./callRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c4ea50",
  null
  
)

export default component.exports